import { types } from "../types/types";

export const SelectedDetailsWorkingTime = (details) => ({
    type: types.workingTimeSelectedDetails,
    payload: details,
  });